import * as React from 'react';
import ReactCountryFlag from 'react-country-flag';
import LocationModel from '../../../../models/locationModel';

interface LocationLabelProps {
  hideName?: boolean;
  hideCode?: boolean;
  hideFlag?: boolean;
  hideCountry?: boolean;

  location: LocationModel;
}

const LocationLabel = (props: LocationLabelProps) => {
  const renderName = () => {
    return !props.hideName && <span className="location-label">{props.location.name}&nbsp;</span>;
  };

  const renderCode = () => {
    return !props.hideCode && <span>{props.location.code}&nbsp;</span>;
  };

  const renderFlag = () => {
    return !props.hideFlag && <ReactCountryFlag countryCode={props.location.countryCode} svg />;
  };

  const renderCountry = () => {
    return (
      !props.hideCountry &&
      props.location.countryCode && <span>({props.location.countryCode})&nbsp;</span>
    );
  };

  if (!props.location) {
    return <span>&nbsp;</span>;
  }

  return (
    <span
      title={`${props.location.name} - ${props.location.code} - ${props.location.countryCode}`}
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {renderName()}
      {renderCode()}
      {renderCountry()}
      {renderFlag()}
    </span>
  );
};

export default LocationLabel;
